/**
 * # SRS 墙踢数据（Standard Rotation System）
 *
 * 每个方块类型有两组偏移表：0→R 和 R→0 等。 索引 0-3 对应 4 个旋转状态（0, R, 2, L）。
 *
 * 格式：[offsetX, offsetY]，正数 X = 右移，正数 Y = 下移
 */

/** I 型方块的墙踢数据 */
export const KICK_I = [
  // 0→R
  [
    [0, 0],
    [-2, 0],
    [1, 0],
    [-2, -1],
    [1, 2],
  ],
  // R→2
  [
    [0, 0],
    [-1, 0],
    [2, 0],
    [-1, 2],
    [2, -1],
  ],
  // 2→L
  [
    [0, 0],
    [2, 0],
    [-1, 0],
    [2, 1],
    [-1, -2],
  ],
  // L→0
  [
    [0, 0],
    [1, 0],
    [-2, 0],
    [1, -2],
    [-2, 1],
  ],
];

// 5 格 I 型专属墙踢数据
export const KICK_I5 = [
  // 0→R (索引 0)
  [
    [0, 0],
    [-2, 0],
    [1, 0],
    [-2, -1],
    [1, 2],
  ],
  // R→2 (索引 1)
  [
    [0, 0],
    [-1, 0],
    [2, 0],
    [-1, 2],
    [2, -1],
  ],
  // 2→L (索引 2)
  [
    [0, 0],
    [2, 0],
    [-1, 0],
    [2, 1],
    [-1, -2],
  ],
  // L→0 (索引 3)
  [
    [0, 0],
    [1, 0],
    [-2, 0],
    [1, -2],
    [-2, 1],
  ],
];

/** J/L/S/Z/T 型方块的墙踢数据 */
export const KICK_JLSZT = [
  // 0→R
  [
    [0, 0],
    [-1, 0],
    [-1, 1],
    [0, -2],
    [-1, -2],
  ],
  // R→2
  [
    [0, 0],
    [1, 0],
    [1, -1],
    [0, 2],
    [1, 2],
  ],
  // 2→L
  [
    [0, 0],
    [1, 0],
    [1, 1],
    [0, -2],
    [1, -2],
  ],
  // L→0
  [
    [0, 0],
    [-1, 0],
    [-1, -1],
    [0, 2],
    [-1, 2],
  ],
];
